function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import utils from "../utils";
import LocalStorageAdapter from "./local_storage_adapter";

var PersistentQueueGoogleAnalyticsAdapter = /*#__PURE__*/function () {
  function PersistentQueueGoogleAnalyticsAdapter() {
    var storage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : LocalStorageAdapter;

    _classCallCheck(this, PersistentQueueGoogleAnalyticsAdapter);

    _defineProperty(this, "namespace", "alephbet");

    _defineProperty(this, "queue_name", "_ga_queue");

    this._storage = storage;
    this._queue = JSON.parse(this._storage.get(this.queue_name) || "[]");

    this._flush();
  }

  _createClass(PersistentQueueGoogleAnalyticsAdapter, [{
    key: "_remove_uuid",
    value: function _remove_uuid(uuid) {
      var _this = this;

      return function () {
        utils.remove(_this._queue, function (el) {
          return el.uuid === uuid;
        });

        _this._storage.set(_this.queue_name, JSON.stringify(_this._queue));
      };
    }
  }, {
    key: "_flush",
    value: function _flush() {
      if (typeof global.ga !== "function") {
        throw new Error("ga not defined. " + "Please make sure your Universal analytics is set up correctly");
      }

      var _iterator = _createForOfIteratorHelper(this._queue),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          var callback = this._remove_uuid(item.uuid);

          global.ga("send", "event", item.category, item.action, item.label, {
            hitCallback: callback,
            nonInteraction: 1
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "_track",
    value: function _track(category, action, label) {
      utils.log("Persistent Queue Google Universal Analytics track", {
        category: category,
        action: action,
        label: label
      });
      if (this._queue.length > 100) this._queue.shift();

      this._queue.push({
        uuid: utils.uuid(),
        category: category,
        action: action,
        label: label
      });

      this._storage.set(this.queue_name, JSON.stringify(this._queue));

      this._flush();
    }
  }, {
    key: "experiment_start",
    value: function experiment_start(experiment, variant) {
      this._track(this.namespace, "".concat(experiment.name, " | ").concat(variant), "Visitors");
    }
  }, {
    key: "goal_complete",
    value: function goal_complete(experiment, variant, goal_name, _props) {
      this._track(this.namespace, "".concat(experiment.name, " | ").concat(variant), goal_name);
    }
  }]);

  return PersistentQueueGoogleAnalyticsAdapter;
}();

export default PersistentQueueGoogleAnalyticsAdapter;